import $ from 'jquery';
import whenDomReady from 'when-dom-ready';

import ViewProduct from 'Views/view-product';
import OneQuickShopv2 from 'Modules/module-oneQuickShopv2';

"use strict";

// Global requires
whenDomReady(function(){
    console.log('init product');
    new ViewProduct({el: $('.product-wrapper')});

    if ( $('.product-wrapper').length && $('.product-wrapper').data('quickshop') ) {
        OneQuickShopv2.init({});
    }

    $('.js-thumbnail--video').on('click', function (event) {
        const thumbnailMedia = event.currentTarget;
        if (!thumbnailMedia) return;

        const mediaIndex = thumbnailMedia.dataset.mediaIndex;
        if (mediaIndex <= 0) return;

        const rightSliderElem = document.querySelector('.js-product-single__slider__for');
        if (!rightSliderElem) return;

        const mediaControllers = Array.from(rightSliderElem.querySelectorAll('.js-media-controller'));
        const matchedMediaController = mediaControllers.find((elem) => elem.dataset.mediaIndex === mediaIndex);
        if (!matchedMediaController) return;

        const video = matchedMediaController.querySelector('.js-video');
        if (!video) return;
        
        video.muted = true; // Ensure video is muted to allow autoplay
        video.play().catch(error => {
            console.error("Autoplay prevented:", error);
        });
    });

    $('.js-media-controller').on('click', function (event) {
        if (window.innerWidth >= 768) return;

        event.preventDefault();
        event.stopPropagation();

        const mediaController = event.currentTarget;
        if (!mediaController) return;

        const video = mediaController.querySelector('.js-video');
        if (!video) return;
        
        video.muted = true; // Ensure video is muted to allow play
        if (isVideoPlaying(video)) {
            video.pause();
        } else {
            video.play().catch(error => {
                console.error("Play prevented:", error);
            });
        }
    });

    function isVideoPlaying(video) {
        return !video.paused && !video.ended && video.readyState > 2;
    }
});